import React from 'react'

import { CrossClientQueryResultCellProps } from './types'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { CrossClientResultMatch } from '../Details/CrossClientResultMatch'

interface CrossClientQueryResultMatchCellProps extends CrossClientQueryResultCellProps {
  onShowDetails: () => void
}

export const CrossClientQueryResultMatchCell: React.FC<CrossClientQueryResultMatchCellProps> = ({ result, onShowDetails }) => {
  const { match } = result

  return (
    <div className='zocks-py-0.75 flex-1'>
      <div className='d-flex'>
        <Tooltip className='zocks-text-gray-500' placement='top' title='View match details'>
          <CrossClientResultMatch match={match} onClick={onShowDetails} />
        </Tooltip>
      </div>
    </div>
  )
}
